module.exports = __webpack_public_path__ + "img/flusher_stopped.9d5da27d.svg";